import { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BadgesIntegration from 'pages/integrations/containers/BadgesContainer/components/BadgesIntegration';
import { badgesActions } from 'pages/integrations/containers/BadgesContainer/actions';

const BadgesContainer = ({ dispatch }) => {
  useEffect(() => {
    dispatch(badgesActions.fetchBadgeConfigs());
  }, [dispatch]);

  return <BadgesIntegration />;
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(badgesActions, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(BadgesContainer);
